import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/home/Home';
import Contact from './pages/contact/Contact';
import Footer from './components/Footer';
import './App.css';
import Navbar from './components/Navbar';

import Login from './pages/user/Login';
import Regsiter from './pages/user/Regsiter';
import Faqs from './pages/faq/Faq';
import Jobs from './pages/jobs/Job';
import Courses from './pages/courses/Courses';
import About from './pages/about/About';
import CourseDetail from './pages/courses/CourseDetail';
import TermsConditions from './pages/term/TermsConditions';
import Career from './pages/career/Career';
import UserDashboard from './pages/user/UserDashboard';
import JobDetail from './pages/jobs/JobDetail';
import ScrollToTop from './pages/TopToBack/ScrollToTop';


import Top from './pages/TopToBack/Top';
import FixedContactButton from './pages/TopToBack/FixedContactButton';
import BlogPage from './pages/blog/Blog';
import BlogDetails from './pages/blog/BlogDetails';
import CartPage from './pages/cart/CartPage';
import CheckoutPage from './pages/cart/CheckoutPage';
import OtpVerification from './pages/user/OtpVerification';
import MyProfile from './pages/user/Myrpofile';
import MyCourse from './pages/user/MyCourse';
import MyJob from './pages/user/MyJob';
import ApplyNow from './pages/apply/JobApplicationForm';

const App = () => {
  return (
    <>
      <Navbar />
      <ScrollToTop />

      <Routes>
        {/* General Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<Faqs />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/career" element={<Career />} />

        {/* Blog */}
        <Route path="/blogs" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetails />} />

        {/* Courses */}
        <Route path="/courses" element={<Courses />} />
        <Route path="/course/:id" element={<CourseDetail />} />
      

        {/* Jobs */}
        <Route path="/job" element={<Jobs />} />
        <Route path="/job/:id" element={<JobDetail />} />
       <Route path="/apply-now" element={<ApplyNow/>} />

        {/* Cart */}
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Regsiter />} />
        <Route path="/otpverify" element={<OtpVerification />} />

        {/* User Dashboard */}
        <Route path="/user" element={<UserDashboard />}>
          <Route path="myprofile" element={<MyProfile />} />
          <Route path="myjobs" element={<MyJob />} />
          <Route path="mycourses" element={<MyCourse />} />
        </Route>

      </Routes>

      <FixedContactButton />
      <Top />
      <Footer />
    </>
  );
};

export default App;
